import { render, staticRenderFns } from "./Courts.vue?vue&type=template&id=d40c7f7c"
import script from "./Courts.vue?vue&type=script&lang=js"
export * from "./Courts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports